import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { StorageService } from 'app/services/storage.service';
import { finalize, filter } from 'rxjs/operators';
import { authCloudService } from 'app/services/authCloud.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ToastService } from 'ng-uikit-pro-standard';
import { TagService } from 'app/services/tag.service';
import { Tag } from 'app/models/tag';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';

@Component({
  selector: 'app-add-cloud-storage',
  templateUrl: './add-cloud-storage.component.html',
  styleUrls: ['./add-cloud-storage.component.scss']
})
export class AddCloudStorageComponent implements OnInit {
  
  dropboxForm: FormGroup;
  
  cloudType: string;
  
  storageId: number;
  
  code: string;
  token: string;

  loading: boolean = false;

  isNgSelectLoading: boolean = false;
  
  constructor(private validationHandler: ValidationHandler, private router: Router,
    public storageService: StorageService, private formBuilder: FormBuilder,
    private authCloudService: authCloudService, private toastService: ToastService,
    public tagService: TagService, private activatedRoute: ActivatedRoute, private ecoDocsTitleService: EcoDocsTitleService) {

      //Validate From for Submition 
    this.dropboxForm = this.storageService.getDropboxFormGroup();

    router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((e:NavigationEnd)=>{
      
      if (activatedRoute.snapshot.params.clouddriver && 
          !activatedRoute.snapshot.params.storageid && 
          !activatedRoute.snapshot.queryParams.code) {
        this.cloudType = activatedRoute.snapshot.params.clouddriver;
        switch (this.cloudType) {
  
          case 'dropbox':
            this.authCloudService.getDropboxCode();
            break;
          case 'google':
            // Google auth Code
            break;
          case 'onedrive':
            // OneDrive auth Code
            break;
          case 'box':
            // Box auth Code
            break;
  
        }
      }
      else if (activatedRoute.snapshot.queryParams.code) {
        this.cloudType = activatedRoute.snapshot.params.clouddriver;
        this.dropboxForm.get('config.code').setValue(activatedRoute.snapshot.queryParams.code);
      }
    });

    //Get FTP driver for edit 
    this.activatedRoute.params.subscribe(params => {
      if (params.storageid) {
        this.storageId = +params.storageid;
        this.loading = true;
        storageService.getById(this.storageId).pipe(finalize(() => {
          this.loading = false;
        })).subscribe(f => {
          this.dropboxForm.patchValue(f);
        });
      }
    });
  }

  ngOnInit() {
    this.ecoDocsTitleService.setTitle( 'Add Cloud Storage', false );
  }

  onAddTag (name: string) {
    this.isNgSelectLoading = true;
    return this.tagService.add(name).pipe(finalize(()=>{
      this.isNgSelectLoading = false;
    })).toPromise();
  }

  submit(frm: FormGroup) {
    this.loading = true;
    if (!frm.valid) {
      this.validationHandler.onSubmitCheck(frm);
        this.loading = false;
        return;
    }
    if (this.storageId) {
      this.storageService.updateDropbox(frm.value).pipe(finalize(() => {
      })).subscribe(t => {
        this.loading = false;
        this.router.navigateByUrl('/manage/storage')
      }, err => {
        this.loading = false;
        if (err.status === 422) {
          this.validationHandler.serverValidationHandler(err, frm);
        } else
          this.toastService.error("Save Failed");
      });
    }
    else {
      this.storageService.addDropbox(frm.value).pipe(finalize(() => {
      })).subscribe(t => {
        this.loading = false;
        this.router.navigateByUrl('/manage/storage')
      }, err => {
        this.loading = false;
        if (err.status === 422) {
          this.validationHandler.serverValidationHandler(err, frm);
        } else
          this.toastService.error("Save Failed");
      });

    }
  }


}
